import React from 'react';
import '../dashboard.css';
import { clampPercent } from '../overview/format';

export interface RingLegendItem {
  key: string;
  label: string;
  value: React.ReactNode;
  color: string;
}

interface CompletionRingProps {
  percent: number;
  /** Caption under the percentage, e.g. "مُنجز". */
  label: string;
  legend?: RingLegendItem[];
}

const RADIUS = 54;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

/** 128px completion ring (plain SVG, no chart library) with an optional legend. */
const CompletionRing: React.FC<CompletionRingProps> = ({ percent, label, legend = [] }) => {
  const pct = clampPercent(percent);
  return (
    <div className="dash-ring-block">
      <div className="dash-ring" role="img" aria-label={`${pct}% ${label}`}>
        <svg width="128" height="128" viewBox="0 0 128 128" aria-hidden="true">
          <circle className="dash-ring-track" cx="64" cy="64" r={RADIUS} fill="none" strokeWidth="12" />
          {pct > 0 && (
            <circle
              className="dash-ring-value"
              cx="64"
              cy="64"
              r={RADIUS}
              fill="none"
              strokeWidth="12"
              strokeLinecap="round"
              strokeDasharray={CIRCUMFERENCE}
              strokeDashoffset={CIRCUMFERENCE * (1 - pct / 100)}
            />
          )}
        </svg>
        <div className="dash-ring-center">
          <b>{pct}%</b>
          <span>{label}</span>
        </div>
      </div>
      {legend.length > 0 && (
        <div className="dash-ring-legend">
          {legend.map((l) => (
            <div key={l.key}>
              <span className="dash-swatch" style={{ background: l.color }} />
              {l.label} <b>{l.value}</b>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CompletionRing;
